import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { SuiModal, ComponentModalConfig, ModalSize, DatepickerMode } from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { OrganizationService } from 'src/modules/features/admin/services';
import { WorkFlowService } from '../../services';
import { debounce, debounceTime, distinctUntilChanged } from 'rxjs/operators';
export function check(array: Array<any>, fieldChecker: string, selectedIds: Array<any>) {
	for (let i = 0; i < array.length; i++) {
		var node = array[i];
		node['selected'] = selectedIds.indexOf(node[fieldChecker]) > -1 ? true : false;
	}
	console.log(selectedIds);
	console.log(array);
	return array;
}
interface IWorkflowGroupAddModalContext {
	data: any;
	title?: string;
	isEdit?: boolean;
}
@Component({
	selector: 'app-workflow-group-add-modal',
	templateUrl: './workflow-group-add-modal.component.html',
	styleUrls: [ './workflow-group-add-modal.component.scss' ]
})
export class WorkflowGroupAddModalComponent implements OnInit, OnDestroy {
	searchable: boolean = true;
	public mode: DatepickerMode = 'year';
	public maxDate = new Date();
	private unsubscribe$: Subject<void> = new Subject<void>();
	formSubmitAttempt: boolean;
	success: any;
	error: any;
	pending: boolean;
	upending: boolean;
	groupForm: FormGroup;
	search: FormControl = new FormControl('');
	users: Array<any> = [];
	units = [ { name: 'WorkflowGroup 1' }, { name: 'WorkflowGroup 2' }, { name: 'WorkflowGroup 3' } ];
	totalItems: number = 0;
	rows: number = 2;
	currentPage: number = 1;
	maxSize: number = 7;
	userSearchFilter = {
		groupOp: 'OR',
		rules: [
			{
				field: 'appUserEmail',
				op: 'cn',
				data: ''
			},
			{
				field: 'username',
				op: 'cn',
				data: ''
			},
			{
				field: 'firstName',
				op: 'cn',
				data: ''
			},
			{
				field: 'lastName',
				op: 'cn',
				data: ''
			}
		]
	};
	userFilter: AppFilter = new AppFilter();
	organizationId: string;
	selectedUserIds: Array<any> = [];
	workFlow;
	selectedWorkFlowGroup;
	constructor(
		private orgSvc: OrganizationService,
		@Inject(DOCUMENT) private document,
		private fb: FormBuilder,
		public modal: SuiModal<IWorkflowGroupAddModalContext, void, void>,
		private workflowService: WorkFlowService
	) {
		this.organizationId = window.localStorage.getItem('organizationId');
		this.groupForm = fb.group({
			name: [ '', Validators.required ]
		});
		console.log(modal.context.data);
		this.workFlow = modal.context.data['workFlow'];
		if (modal.context.isEdit == true) {
			this.workFlow = modal.context.data;
			this.selectedWorkFlowGroup = modal.context.data['selectedGroup'];
			this.selectedUserIds = modal.context.data['selectedGroup']['appUsersId'];
			console.log(this.selectedUserIds);
		}
		this.search.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((searchText) => {
			// this.userSearchFilter.rules[1].data = searchText;
			this.userSearchFilter.rules[0].data = searchText;
			this.userSearchFilter.rules[1].data = searchText;
			this.userSearchFilter.rules[2].data = searchText;
			this.userSearchFilter.rules[3].data = searchText;
			this.userFilter.page = 1;
			this.userFilter.filters = JSON.stringify(this.userSearchFilter);
			this.getUsers();
		});
		this.getUsers();
	}

	getUsers() {
		this.userFilter.rows = 100000;
		this.upending = true;
		this.orgSvc.getUsers({ organizationId: this.organizationId, params: this.userFilter }).subscribe((res) => {
			this.users = check(
				res['rows'].filter((user) => user.firstName !== null),
				'appUserId',
				this.selectedUserIds
			);
			this.upending = false;
		});
	}
	selectUser(lab) {
		// alert(JSON.stringify(lab))
		this.selectedUserIds.indexOf(lab['appUserId']) > -1
			? this.remove(lab['appUserId'])
			: this.selectedUserIds.push(lab['appUserId']);
		// this.selectedUserId = lab.appUserId;

		lab.selected = !lab.selected;
	}
	remove(docId: string) {
		for (let i = 0; i < this.selectedUserIds.length; i++) {
			if (this.selectedUserIds[i] == docId) {
				this.selectedUserIds.splice(i, 1);
				break;
			}
		}
	}
	isFieldValid(field: string) {
		return (
			(!this.groupForm.get(field).valid && this.groupForm.get(field).touched) ||
			(this.groupForm.get(field).untouched && this.formSubmitAttempt)
		);
	}

	displayFieldCss(field: string) {
		return {
			error: this.isFieldValid(field)
		};
	}

	displayFormCss(field: string) {
		return {
			loading: field
		};
	}
	submit() {
		this.modal.context.isEdit ? this.updateGroup() : this.save();
	}
	save() {
		this.formSubmitAttempt = false;
		if (this.groupForm.valid) {
			this.pending = true;
			let group: Array<any> = [ { name: this.groupForm.value.name, appUserIds: this.selectedUserIds } ];
			this.workflowService
				.addWorkFlow({
					organizationId: this.organizationId,
					body: {
						workFlowType: this.modal.context.data['workFlowType'],
						firstDescription: this.modal.context.data['firstDescription'],
						workFlowGroups: [ ...this.modal.context.data['workFlowGroups'], ...group ]
					}
				})
				.subscribe(
					() => {
						this.pending = false;
						this.success = 'Workflow added successfully';
						setTimeout(() => {
							this.modal.approve(null);
						}, 2000);
					},
					(error) => {
						this.pending = false;
						this.error = error.error;
					}
				);
		} else {
			this.formSubmitAttempt = true;
		}
	}

	updateGroup() {
		this.upending = true;
		let group: Array<any> = [ { name: this.groupForm.value.name, appUserIds: this.selectedUserIds } ];
		this.workflowService
			.updateWorkFlowUsers({
				workFlowType: this.workFlow.jpaWorkflowGroupViewPK.workflowType,
				workFlowId: this.workFlow.jpaWorkflowGroupViewPK.workflowGroupId,
				organizationId: this.organizationId,
				body: { ids: this.selectedUserIds }
			})
			.subscribe(
				(res) => {
					this.upending = false;
					this.success = 'User added to workflow group successfully';
					setTimeout(() => {
						this.modal.approve(null);
					}, 2000);
				},
				(error) => {
					this.upending = false;
					this.error = error.error;
				}
			);
	}
	// 		addUser(user) {
	//       if (this.userForm.valid) {
	//         this.loading = true;
	//         this.workflowService.updateWorkFlowUsers({

	//         }).pipe(
	//           takeUntil(this.unsubscribe$)
	//         ).subscribe(res => {
	//           this.loading = false;
	//           this.successMessage = 'User added to workflow group successfully';
	//           setTimeout(() => {
	//               this.getPage(1);
	//           }, 700);
	//         }, error => {
	//             this.loading = false;
	//             this.error = error.error;
	//           });
	//       } else {
	//         this.errorMessage = 'Please select a user';
	//       }
	//   }
	addWorkflowGroup() {
		let type: any = 'addunit';
		this.modal.approve(type);
	}
	nullify() {
		this.success = null;
		this.error = null;
	}
	ngOnInit() {
		// this.document.body.classList.remove('panel');
	}
	// s
	ngOnDestroy(): void {
		// this.document.body.classList.add('panel');
	}
}

export class WorkflowGroupAddModal extends ComponentModalConfig<IWorkflowGroupAddModalContext, void, void> {
	constructor(title: string, data: any, isEdit: boolean, size: ModalSize = ModalSize.Small) {
		super(WorkflowGroupAddModalComponent, { title, data, isEdit });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.transition = 'slide left';
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
